import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { formatPrice } from '../mock';
import { toast } from 'sonner';
import { getProductCardImages } from '../lib/api';

const ProductCard = ({ product }) => {
  const { addItem } = useCart();

  if (!product) return null;

  const { image, hoverImage } = getProductCardImages(product);
  const productId = product.id;
  const isOnSale = Boolean(product.originalPrice && Number(product.originalPrice) > Number(product.price));

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Pass the resolved card image: raw backend products only carry an `images`
    // array with relative URLs, so `product.image` would be empty in the cart.
    addItem({ ...product, image });
    toast.success('Added to cart', { description: product.name });
  };

  return (
    <Link to={`/products/${productId}`} className="product-card block group">
      <div className="relative overflow-hidden bg-[#f7f4ee] aspect-[3/4]">
        <img src={image} alt={product.name} loading="lazy" decoding="async" className="img-primary absolute inset-0 w-full h-full object-cover" />
        <img src={hoverImage} alt="" loading="lazy" decoding="async" className="img-hover absolute inset-0 w-full h-full object-cover" />
        <button
          onClick={handleAdd}
          className="hidden sm:block sm:absolute sm:inset-x-3 sm:bottom-3 bg-[#999959] text-[#FFFFFF] text-[11px] tracking-widest-2 uppercase py-3 opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500 hover:bg-[#7d8449]"
        >
          Add to Cart
        </button>
      </div>
      <div className="mt-4 text-center">
        <div className="font-serif text-[17px] text-[#1a1a1a] leading-snug">{product.name}</div>
        <div className="text-[13px] text-[#5a5346] mt-1.5 flex items-center justify-center gap-2">
          {isOnSale ? (
            <>
              <span className="line-through text-[#9a9386] font-normal">{formatPrice(product.originalPrice)}</span>
              <span className="font-medium text-[#1a1a1a]">{formatPrice(product.price)}</span>
            </>
          ) : (
            <span>{formatPrice(product.price)}</span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
